import { TrendingUp } from "lucide-react";
import { useTopPackages } from "../../Subscriptions/hooks/useTopPackages";

export default function PackagePerformance() {
  const topPackages = useTopPackages();

  return (
    <div className="bg-card rounded-lg flex flex-col gap-y-4 p-7">
      <h1 className="text-white text-md">Package Performance</h1>

      {topPackages.map((pkg) => (
        <div
          key={pkg.packageName}
          className="flex items-center justify-between"
        >
          <div className="flex items-center gap-x-2">
            <div className="w-2 h-2 bg-green-500 rounded-full"></div>
            <div className="flex flex-col text-white text-sm">
              <p>{pkg.packageName}</p>
              <p>{pkg.subscribers} Subscribers</p>
            </div>
          </div>
          <div className="flex flex-col text-sm">
            <p className="text-white">
              MWK {pkg.totalRevenue.toLocaleString()}
            </p>
            <div className="flex items-center gap-x-1">
              <TrendingUp className="text-green-500" size={18} />
              {/* Placeholder growth % for now */}
              <p className="text-green-500">+12%</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
